import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import StripeCustomerSearch from '../vue_widgets/organizations/stripe_customer_search.vue'

export default class extends Controller {
  static values = {
    organizationId: String,
    hasPayCustomer: Boolean
  }

  connect() {
    // Only mount widget if organization doesn't have Pay::Customer
    if (!this.hasPayCustomerValue) {
      this.mountStripeCustomerSearch()
    }
  }

  disconnect() {
    this.vueApp?.unmount()
  }

  mountStripeCustomerSearch() {
    const container = this.element.querySelector('[data-stripe-customer-search]')
    if (!container) return

    this.vueApp = createApp(StripeCustomerSearch, {
      organizationId: this.organizationIdValue
    })

    this.vueApp.mount(container)
  }
}
